import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    title: _ctx.t('UPDATE_ASSET_CLASSIFICATION', { asset: _ctx.leadTypeLabel.toLowerCase() }),
    onConfirm: _ctx.validateAndSubmit,
    onCancel: _ctx.cancel,
    loading: _ctx.loading,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card_section, { class: "q-pa-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            greedy: "",
            id: "asset-edition-form",
            ref: "assetEditionForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_input, _mergeProps(_ctx.INPUT_LG, {
                label: _ctx.t('NAME'),
                modelValue: _ctx.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
              }), null, 16, ["label", "modelValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.galenicForms,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.galenicForms) = $event)),
                label: _ctx.t('GALENIC_FORM'),
                options: _ctx.galenicFormsOptions,
                "max-values": "5"
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                "allow-create": _ctx.canCreateGalenicForm && _ctx.isAllowedGalenicForm,
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterGalenicFormsOptions,
                "selected-item-slot": "",
                onCreateValue: _ctx.createGalenicForm
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "allow-create", "placeholder-value", "onFilter", "onCreateValue"]),
              _createVNode(_component_iuf_select, _mergeProps({
                modelValue: _ctx.categories,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.categories) = $event)),
                label: _ctx.t('CATEGORIES'),
                options: _ctx.categoriesOptions
              }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                "allow-create": _ctx.canCreateCategory && _ctx.isAllowedCategory,
                "max-value": "5",
                "option-label": "label",
                "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                "option-value": "dobjId",
                onFilter: _ctx.filterCategoriesOptions,
                "selected-item-slot": "",
                onCreateValue: _ctx.createCategory
              }), {
                "selected-item": _withCtx((scope) => [
                  (_openBlock(), _createBlock(_component_iap_chip, {
                    tooltip: "",
                    label: scope.opt.label,
                    key: scope.opt.dobjId,
                    removable: "",
                    onRemove: ($event: any) => (scope.removeAtIndex(scope.index))
                  }, null, 8, ["label", "onRemove"]))
                ]),
                _: 1
              }, 16, ["modelValue", "label", "options", "allow-create", "placeholder-value", "onFilter", "onCreateValue"]),
              _createVNode(_component_q_input, _mergeProps({
                label: _ctx.t('DESCRIPTION'),
                placeholder: _ctx.t('PLACEHOLDER.DESCRIPTION'),
                "input-class": "'text-body1 text-primary-darker'"
              }, _ctx.TEXTAREA_LG, {
                modelValue: _ctx.description,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event))
              }), null, 16, ["label", "placeholder", "modelValue"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "onConfirm", "onCancel", "loading"]))
}